import PropTypes from 'prop-types';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import {parseMessage} from '../../../../../lib/stringHelper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemPrecisionDispense({task, onChange}) {
  const label = parseMessage('protocolEditor.taskList.pipettingProfile.enablePrecisionDispense');

  return (
    <PipettingProfileItemWrapper>
      {label}
      <PipettingProfileInputType.Switch checked={task?.precisionDispense} onChange={onChange} />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemPrecisionDispense.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default PipettingItemPrecisionDispense;
